'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _academicUsers = require('redux/modules/academicUsers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAcademicDownloads = (_dec = (0, _reactRedux.connect)(null, { download: _academicUsers.download }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(UserAcademicDownloads, _React$Component);

  function UserAcademicDownloads() {
    (0, _classCallCheck3.default)(this, UserAcademicDownloads);
    return (0, _possibleConstructorReturn3.default)(this, (UserAcademicDownloads.__proto__ || (0, _getPrototypeOf2.default)(UserAcademicDownloads)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserAcademicDownloads, [{
    key: 'render',
    value: function render() {
      var styles = require('./UserAcademicDownloads.scss');

      var _props = this.props,
          assetPacks = _props.assetPacks,
          download = _props.download;


      var onDownloadClick = function onDownloadClick(id) {
        return download.bind(null, id);
      };

      return _react2.default.createElement(
        _components.InfoBox,
        { title: 'Student Package Downloads', icon: '/icons/license.svg' },
        _react2.default.createElement(
          'p',
          { className: styles.headerDescription },
          'Student packages are curated packs of Megascans assets. As part of your student license, downloadable files and their limits are listed below.'
        ),
        _react2.default.createElement(
          'table',
          { className: styles.studentPackagesTable },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Package'
              ),
              _react2.default.createElement(
                'th',
                null,
                'Available Downloads'
              ),
              _react2.default.createElement('th', null)
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            assetPacks.map(function (_ref) {
              var id = _ref.id,
                  name = _ref.name,
                  downloadCount = _ref.downloadCount,
                  limit = _ref.limit;
              return _react2.default.createElement(
                'tr',
                { key: id },
                _react2.default.createElement(
                  'td',
                  null,
                  name
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  limit - downloadCount,
                  ' / ',
                  limit
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(_components.Button, { primary: true, small: true, label: 'Download', onClick: onDownloadClick(id) })
                )
              );
            })
          )
        )
      );
    }
  }]);
  return UserAcademicDownloads;
}(_react2.default.Component), _class2.propTypes = {
  download: _react.PropTypes.func.isRequired,
  assetPacks: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    id: _react.PropTypes.string,
    name: _react.PropTypes.string,
    downloadCount: _react.PropTypes.number,
    limit: _react.PropTypes.limit
  }))
}, _class2.defaultProps = {
  assetPacks: []
}, _temp)) || _class);
exports.default = UserAcademicDownloads;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAcademicDownloads/UserAcademicDownloads.jsx
// module id = 2739
// module chunks = 0